//@flow
import ReactDOM from 'react-dom';
import { IntlProvider } from 'dibs-react-intl';
import { UIDProvider } from 'dibs-uid';
import { combineReducers, createStore } from 'redux';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import dblReducers from 'dibs-buyer-layout/src/reducers';
import SV from 'server-vars';
import { getEnvironment } from '../relayModernEnvironment';

import { DesignProfileContainer } from '../designProfile/DesignProfileContainer';
import { InternalProfileRedirect } from '../designProfile/InternalProfileRedirect';
import getAdminHost from '../designProfile/helpers/getAdminHost';

const locale = SV.get('localeDataKey');
const messages = SV.get('messages');
const isAdminMode = SV.get('isAdminMode');
const adminHost = getAdminHost();

type BootstrapType = {
    store?: any,
};

function createReduxStore(additionalReducers = {}, state = {}) {
    const reducers = combineReducers({ ...dblReducers, ...additionalReducers });
    return createStore(reducers, state);
}

new Promise(resolve => {
    if (isAdminMode) {
        return resolve({ store: createReduxStore() });
    }
    return resolve(initializeDBL());
}).then(({ store }: BootstrapType) => {
    const initialPage = SV.get('initialPage');
    const firmUrlLabel = SV.get('firmUrlLabel');
    const isEditMode = SV.get('isEditMode');
    const isTrade = SV.get('userType') === 'trade';
    const firmId = SV.get('firmId');
    const pointUserToAdminSite = SV.get('pointUserToAdminSite');
    const isMobile = SV.get('settings.isMobile');
    // Because the edit call requires a valid userToken, the standard `relayEnvironment` can't be used;
    // to populate the result of the edit SSR, use a different namespace to avoid clobbering the
    // existing `dbl.relayData` result (which will contain data for the header & footer, among other things)
    const environment = getEnvironment(isEditMode ? false : true);

    // if the user is an admin trying to access the user's design profile
    if (pointUserToAdminSite) {
        ReactDOM.render(
            <InternalProfileRedirect firmId={firmId} />,
            document.getElementById('js-root')
        );
    } else {
        const designProfileDOMNode = document.getElementById('designProfilesContainer');
        const designProfile = (
            <DesignProfileContainer
                store={store}
                adminHost={adminHost}
                initialPage={initialPage}
                firmUrlLabel={firmUrlLabel}
                isEditMode={isEditMode}
                isAdminMode={isAdminMode}
                isTrade={isTrade}
                isMobile={isMobile}
                environment={environment}
            />
        );

        if (designProfileDOMNode !== null) {
            if (isAdminMode) {
                ReactDOM.render(
                    <UIDProvider>
                        <IntlProvider locale={locale} messages={messages}>
                            {designProfile}
                        </IntlProvider>
                    </UIDProvider>,
                    designProfileDOMNode
                );
            } else {
                ReactDOM.hydrate(
                    <UIDProvider>
                        <IntlProvider locale={locale} messages={messages}>
                            {designProfile}
                        </IntlProvider>
                    </UIDProvider>,
                    designProfileDOMNode
                );
            }
        }
    }
});
